import PermIdentity from '@material-ui/icons/PermIdentity';
import {PromotionalGoodList} from "./PromotionalGoodList";
import {PromotionalGoodCreate} from "./PromotionalGoodCreate";
import {PromotionalGoodEdit} from "./PromotionalGoodEdit";
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: PromotionalGoodList,
    create: PromotionalGoodCreate,
    edit: PromotionalGoodEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;